import { useStore } from 'components/contexts/responsive'

const useScreenClass = () => {
  const { screenClass, isMobile, isDesktop } = useStore()

  return { screenClass, isMobile, isDesktop }
}

export default useScreenClass
